import { useRutilusQuery } from '../../../../../api/graphql/useRutilusQuery';
import { getNodesFromConnection } from '../../../../../helpers/graphql';
import { GetPostLikers, GetPostLikersVariables } from '../../../../../interfaces/graphql';
import { getPostLikers } from '../../../../../queries/rutilus/Posts';
import { isLiker } from '../../../types/isLiker';
import type { Liker } from '../../../types/Liker';

interface CatchLikersData {
  likers: Liker[];
  isLoading: boolean;
}

export const usePostLikers = (postId: string): CatchLikersData => {
  const { data, loading: isLoading } = useRutilusQuery<GetPostLikers, GetPostLikersVariables>(
    getPostLikers,
    {
      variables: { externalId: postId },
      fetchPolicy: 'cache-and-network',
    },
  );
  const likers = getNodesFromConnection(data?.post.likers).filter(isLiker);

  return { likers, isLoading };
};
